export class BaseTable {
  number: number;
  description: string;
  extraDate: Date;
  extraNumber: number;
  tableNumber: number;
  numberStr: string;
}
